import { I18n } from 'lib/i18n'
import { del, get, patch, upload } from 'lib/utilities'
import { toast } from 'react-toastify'

export const CREATE = 'media/CREATE'
export const CREATE_DONE = 'media/CREATE_DONE'
export const CREATE_FAILED = 'media/CREATE_FAILED'

export const CLEAR_CREATED_MEDIA = 'media/CLEAR_CREATED_MEDIAL'

export const REPLACE = 'media/REPLACE'
export const REPLACE_DONE = 'media/REPLACE_DONE'
export const REPLACE_FAILED = 'media/REPLACE_FAILED'

export const LOAD = 'media/LOAD'
export const LOAD_DONE = 'media/LOAD_DONE'
export const LOAD_FAILED = 'media/LOAD_FAILED'

export const SAVE = 'media/SAVE'
export const SAVE_DONE = 'media/SAVE_DONE'
export const SAVE_FAILED = 'media/SAVE_FAILED'

export const DELETE = 'media/DELETE'
export const DELETE_DONE = 'media/DELETE_DONE'
export const DELETE_FAILED = 'media/DELETE_FAILED'

export const TOGGLE_VIEW_STYLE = 'media/TOGGLE_VIEW_STYLE'
export const SET_PAGE = 'media/SET_PAGE'
export const SET_PROGRESS = 'media/SET_PROGRESS'

export const SET_PROPERTIES = 'media/SET_PROPERTIES'

export const createMedium = (files, singleDropzoneUpload = false) => ({
  type: CREATE,
  files,
  singleDropzoneUpload,
})
export const createMediumFulfilled = (files) => ({ type: CREATE_DONE, files })
export const createMediumFailed = (errors) => ({ type: CREATE_FAILED, errors })

export const clearCreatedMedia = () => ({ type: CLEAR_CREATED_MEDIA })

export const loadMedia = () => ({ type: LOAD })
export const loadMediaFulfilled = (media) => ({ type: LOAD_DONE, media })
export const loadMediaFailed = (errors) => ({ type: LOAD_FAILED, errors })

export const replaceMedium = (id, file, singleDropzoneUpload = false) => ({
  type: REPLACE,
  id,
  file,
  singleDropzoneUpload,
})
export const replaceMediumFulfilled = () => ({ type: REPLACE_DONE })
export const replaceMediumFailed = (errors) => ({
  type: REPLACE_FAILED,
  errors,
})

export const saveMedium = (medium) => ({ type: SAVE, medium })
export const saveMediumFulfilled = () => ({ type: SAVE_DONE })
export const saveMediumFailed = (errors) => ({ type: SAVE_FAILED, errors })

export const deleteMedium = (id) => ({ type: DELETE, id })
export const deleteMediumFulfilled = () => ({ type: DELETE_DONE })
export const deleteMediumFailed = (errors) => ({ type: DELETE_FAILED, errors })

export const toggleViewStyle = () => ({ type: TOGGLE_VIEW_STYLE })
export const setPageNumber = (pageNumber) => ({ type: SET_PAGE, pageNumber })
export const setProgress = (progress) => ({ type: SET_PROGRESS, progress })

export const setProperties = (medium) => ({ type: SET_PROPERTIES, medium })

const initialState = {
  viewAsList: true,
  media: [],
  filterText: '',
  typeFilter: null,
  pageNumber: 0,
  itemsPerView: 20,
  itemsPerRow: 5,
  showEditModal: false,
}

export const mediaReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_VIEW_STYLE:
      return { ...state, viewAsList: !state.viewAsList }
    case CREATE:
      return {
        ...state,
        uploadingMedia: true,
        singleDropzoneUpload: action.singleDropzoneUpload,
      }
    case CREATE_DONE:
      return { ...state, uploadingMedia: false, createdMedia: action.files }
    case CREATE_FAILED:
      return { ...state, uploadingMedia: false, singleDropzoneUpload: false }
    case CLEAR_CREATED_MEDIA:
      return { ...state, createdMedia: null, singleDropzoneUpload: false }
    case REPLACE:
      return {
        ...state,
        uploadingMedia: true,
        singleDropzoneUpload: action.singleDropzoneUpload,
      }
    case REPLACE_DONE:
      return { ...state, uploadingMedia: false, singleDropzoneUpload: false }
    case REPLACE_FAILED:
      return { ...state, uploadingMedia: false, singleDropzoneUpload: false }
    case LOAD:
      return { ...state, loadingMedia: true }
    case LOAD_DONE:
      return {
        ...state,
        loadingMedia: false,
        uploadingMedia: false,
        media: action.media,
      }
    case SET_PAGE:
      return { ...state, pageNumber: Math.max(0, action.pageNumber) }
    case SET_PROGRESS:
      return { ...state, uploadProgress: action.progress }
    case SET_PROPERTIES:
      const index = state.media.findIndex(
        (medium) => medium.id === action.medium.id
      )
      if (index === -1) return state
      const changedMedium = { ...state.media[index], ...action.medium }
      return {
        ...state,
        media: [
          ...state.media.slice(0, index),
          changedMedium,
          ...state.media.slice(index + 1),
        ],
      }
    default:
      return state
  }
}

export const createEpic = (action$, store) =>
  action$
    .ofType(CREATE)
    .mergeMap((action) =>
      upload('/assets', action.files, 'POST', (percent) => {
        store.dispatch(setProgress(percent))
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.media/CREATE_MEDIUM_DONE'))
        return [createMediumFulfilled(result.body), loadMedia()]
      } else {
        toast.error(I18n.t('action.media/CREATE_MEDIUM_FAILED'))
        return [result.body && createMediumFailed(result.body.errors)]
      }
    })

export const replaceEpic = (action$, store) =>
  action$
    .ofType(REPLACE)
    .mergeMap((action) => upload('/assets/' + action.id, action.file, 'PUT'))
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.media/REPLACE_MEDIUM_DONE'))
        return [replaceMediumFulfilled(), loadMedia()]
      } else {
        toast.error(I18n.t('action.media/REPLACE_MEDIUM_FAILED'))
        return [result.body && replaceMediumFailed(result.body.errors)]
      }
    })

export const saveEpic = (action$, store) =>
  action$.ofType(SAVE).mergeMap((action) =>
    patch('/assets/' + action.medium.id, { asset: action.medium }).mergeMap(
      (result) => {
        console.debug('media::', result)
        if (result.ok) {
          toast.success(I18n.t('action.media/SAVE_MEDIUM_DONE'))
          return [
            saveMediumFulfilled(),
            setProperties(action.medium),
            loadMedia(),
          ]
        } else {
          toast.error(I18n.t('action.media/SAVE_MEDIUM_FAILED'))
          return [result.body && saveMediumFailed(result.body.errors)]
        }
      }
    )
  )

export const deleteEpic = (action$, store) =>
  action$
    .ofType(DELETE)
    .mergeMap((action) => del('/assets/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.media/DELETE_MEDIUM_DONE'))
        return [deleteMediumFulfilled(), loadMedia()]
      } else {
        toast.error(I18n.t('action.media/DELETE_MEDIUM_FAILED'))
        return [result.body && deleteMediumFailed(result.body.errors)]
      }
    })

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/assets.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadMediaFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.media/LOAD_MEDIA_FAILED'))
        return [result.body && loadMediaFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/media.js